/* custom-personalize.js
 * Personalize trong Custom Buy Buttons — PORT cơ chế theme cũ (assets/store.customize.js).
 *
 * Form options (Design + Font Style + Your personalisation) KHÔNG hardcode nữa mà do app
 * Globo Product Options render (.gpo-container / .gpo-app). JS này dời .gpo-container của app
 * vào panel personalize ([data-personalize-globo-mount]) — giống movePersonlizedProductForm() cũ —
 * để đổ ĐỦ option theo từng sản phẩm. Nút "Personalize your product" toggle hiện/ẩn panel.
 *
 * - Dùng EVENT DELEGATION trên document: block .custom-buy-buttons bị theme swap mỗi lần đổi
 *   variant → handler gắn trực tiếp sẽ mất; delegation không bị ảnh hưởng.
 * - Quan sát DOM (Globo inject bất đồng bộ + theme swap block) để re-mount form Globo.
 * - Ẩn nút ATC riêng của Globo, dùng nút ADD TO CART của theme.
 */
(function () {
  'use strict';

  // Marker kiểm tra deploy (gõ window.__cpVersion trong Console)
  window.__cpVersion = 'v8-globo';

  /* ----- Click delegation: toggle panel + lightbox ----- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    // 1) Toggle form personalize
    var toggle = t.closest('[data-personalize-toggle]');
    if (toggle) {
      var root = toggle.closest('[data-personalize]');
      var panel = root && root.querySelector('[data-personalize-panel]');
      if (panel) {
        var open = panel.hidden; // đang ẩn → mở
        panel.hidden = !open;
        root.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    // 2) Mở lightbox preview font (bấm "Click to enlarge" HOẶC bấm vào ảnh preview)
    var enlarge = t.closest('[data-personalize-enlarge]') || t.closest('.custom-personalize__preview');
    if (enlarge) {
      var rootE = enlarge.closest('[data-personalize]');
      var dlg = rootE && rootE.querySelector('[data-personalize-lightbox]');
      if (dlg) {
        if (typeof dlg.showModal === 'function') dlg.showModal();
        else dlg.setAttribute('open', '');
      }
      return;
    }

    // 3) Đóng lightbox (nút close)
    var closeBtn = t.closest('[data-personalize-lightbox-close]');
    if (closeBtn) {
      var dlg2 = closeBtn.closest('[data-personalize-lightbox]');
      if (dlg2 && dlg2.close) dlg2.close();
      return;
    }

    // 4) Đóng lightbox khi click ra nền dialog
    if (t.matches && t.matches('[data-personalize-lightbox]') && t.close) {
      t.close();
    }
  });

  /* ----- Dời form Globo vào panel personalize ----- */
  var hadGlobo = false; // Globo đã vẽ form ít nhất 1 lần trên trang này

  function mountGlobo() {
    var mount = document.querySelector('[data-personalize-globo-mount]');
    if (!mount) return;

    // Đã có form Globo trong mount → không làm gì (tránh loop với MutationObserver)
    if (mount.querySelector('.gpo-container, .gpo-app')) {
      hadGlobo = true;
      return;
    }

    // App Globo inject .gpo-container ở vị trí mặc định → dời vào mount
    var globo = document.querySelector('.gpo-container');
    if (globo && !mount.contains(globo)) {
      hadGlobo = true;
      mount.appendChild(globo);
      globo.style.display = ''; // CSS app để display:none → mở ra trong panel
      return;
    }

    // TLB 01/10/2026 (việc 2026-10-01-sua-loi-theme-sau-soat, mục 14): đổi biến thể (màu, YES khắc tên) → theme thay cả
    // khối nút mua, form Globo mất theo và app không tự vẽ lại → khách không còn ô gõ tên. Khối mới chưa có form thì gọi
    // Globo vẽ lại, mỗi khối 1 lần (data-gpo-reinit) để không lặp với MutationObserver.
    if (!globo && hadGlobo && !mount.hasAttribute('data-gpo-reinit') &&
        window.GPOConfigs && typeof window.GPOConfigs.initialize === 'function') {
      mount.setAttribute('data-gpo-reinit', '');
      try {
        window.GPOConfigs.initialize();
      } catch (e) {
        /* app lỗi thì giữ như cũ */
      }
    }
  }

  /* ----- Quan sát DOM: Globo inject async + theme swap block khi đổi variant ----- */
  var raf = null;
  var observer = new MutationObserver(function () {
    if (raf) return; // debounce: gộp nhiều mutation vào 1 lần chạy
    raf = (window.requestAnimationFrame || window.setTimeout)(function () {
      raf = null;
      mountGlobo();
    }, 0);
  });

  // Đánh dấu body để giữ style pill cho nút variant (Name Engraving) — KHÔNG còn ẩn Globo
  function markBody() {
    if (document.querySelector('[data-personalize]')) {
      document.body.classList.add('template-personalize');
    }
  }

  function init() {
    markBody();
    mountGlobo();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme swap section trong editor / khi đổi variant → mount lại
  document.addEventListener('shopify:section:load', function () {
    markBody();
    mountGlobo();
  });
})();